import parseDate from "date-fns/parse";
import startOfMonth from "date-fns/startOfMonth";
import { CurbsuiteTransactionLogEntry } from "common/graphql/queries/GetCurbsuiteTransactions";

export type SessionTimeRow = Pick<CurbsuiteTransactionLogEntry, "startTime" | "endTime"> & {
  transaction: Pick<CurbsuiteTransactionLogEntry["transaction"], "sessionStartedAtLocal" | "sessionEndedAtLocal">;
};

export function getSessionStartDate(row: SessionTimeRow): Date {
  return new Date(row.transaction.sessionStartedAtLocal || row.startTime || 0);
}

export function getSessionEndDate(row: SessionTimeRow): Date {
  return new Date(row.transaction.sessionEndedAtLocal || row.endTime || 0);
}

type ReconciledMonthRow = Pick<CurbsuiteTransactionLogEntry, "transactionType"> & {
  transaction: Pick<CurbsuiteTransactionLogEntry["transaction"], "gatewayTransactions" | "sessionStartedAtLocal">;
};

/**
 * The month a permit reconciliation charge *covers*, rather than the date it settled (AUT-4781).
 *
 * The month-end charging script writes its -start-date/-end-date onto the gateway transaction's
 * session period, so that period -- not the settlement date -- is the month finance means. Returns
 * null for every other gateway type (wallet reloads, new-account credits, session payments), which
 * have no reconciled period and should fall through to the caller's own date (AUT-4823 /
 * Zendesk #3443).
 *
 * Shared by the bus-station "Event Date" column and the airport "Month" column so the derivation
 * exists once.
 */
export function getReconciledMonth(row: ReconciledMonthRow): Date | null {
  const gatewayType = row.transaction.gatewayTransactions[0]?.gatewayTransactionType;
  if (
    row.transactionType === "gateway_transaction" &&
    gatewayType === "permit" &&
    row.transaction.sessionStartedAtLocal
  ) {
    return startOfMonth(parseDate(row.transaction.sessionStartedAtLocal.slice(0, 10), "yyyy-MM-dd", new Date()));
  }
  return null;
}
